import { useEffect } from 'react';

const Team = ({ team, matchup, type, click, picks }) => {

    const t = team.team;
    const pickedTeams = Object.values(picks).map(entry => entry.pick);

    return (
        <div id={`teamid-${t.name}`} className={`${type} team ${pickedTeams.includes(t.name) ? "selected" : ""}`} onClick={() => click(t.name, matchup, 1, 1)}>
            <div className="teamLogo">
                <img src={t.logo} alt="Ravens" />
            </div>

            <div className="circle">?</div>

            <p>{t?.name}<br />{team?.records?.length > 0 && team?.records[0].summary}</p>

            <style>
                {`
                    #teamid-${t.name}.selected .teamLogo {
                        box-shadow: 0 0 0 3px #${t.color} inset;
                        border: 2px solid white;
                        animation: pop-${t.name} 0.3s ease-out;
                        transition: 0.3s ease-out;
                    }

                    @keyframes pop-${t.name} {
                        0% {
                            box-shadow: 0 0 0 60px #${t.color} inset;
                        }
                        50%{

                        }
                        100% {
                            box-shadow: 0 0 0 3px #${t.color} inset;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export { Team };
